export const processUsername = (username) => {
  return username.startsWith("0") ? username.substring(1) : username;
};
